module.exports = __webpack_public_path__ + "static/media/Icon Tech.5004fd1f.svg";